import { Country, Follow } from '@app/models';
import { Action } from '@ngrx/store';

export enum FollowActionTypes {
  Load = '[API] Load follows',
  LoadSuccess = '[API] Load follows Success',
  LoadFail = '[API] Load follows Fail',
  LoadSingle = '[API] Load single follow',
  LoadSingleSuccess = '[API] Load single follow Success',
  LoadSingleFail = '[API] Load single follow Fail',
  LoadCountries = '[API] Load follow countries',
  LoadCountriesSuccess = '[API] Load follow countries Success',
  LoadCountriesFail = '[API] Load follow countries Fail',
  SetCountries = '[Follow] Set Countries',
  CreateSetting = '[API] Create follow setting',
  CreateSettingSuccess = '[API] Create follow setting success',
  CreateSettingFail = '[API] Create follow setting fail',
  UpsertSetting = '[Follow] Upsert setting',
  AddOne = '[Follow] Add one',
  Destroy = '[API] Destroy follow',
  DestroySuccess = '[API] Destroy follow success',
  DestroyFail = '[API] Destroy follow fail',
  RemoveOne = '[Follow] Remove one',
  Update = '[API] Update follow',
  UpdateSuccess = '[API] Update follow success',
  UpdateFail = '[API] Update follow fail',
  UpdateOne = '[Follow] Update one',
  Search = '[Follow] search follow ids by conditions',
  SearchSuccess = '[Follow] search follow ids success',
  SearchFail = '[Follow] search follow ids failed',
  SearchClear = '[Product] clear search',
  SearchFollow = '[Follow] search follows by conditions',
  SearchFollowSuccess = '[Follow] search follows success',
  SearchFollowFail = '[Follow] search follows failed',
  SearchFollowClear = '[Product] clear search follow',
  GetBannerShowroomFood = '[Follow] Get banner showroom food',
  GetBannerShowroomFoodSuccess = '[Follow] Get banner showroom food success',
  GetBannerShowroomFoodFail = '[Follow] Get banner showroom food fail',
  GetBannerLink = '[Follow] Get banner link',
  GetBannerLinkFail = '[Follow] Get banner link fail',
  UploadBanner = '[Follow] Upload banner',
  UploadBannerFail = '[Follow] Upload banner fail',
  UploadBannerSuccess = '[Follow] Upload banner success',
  DeleteBanner = '[Follow] Delete banner',
  DeleteBannerSuccess = '[Follow] Delete banner success',
  DeleteBannerFail = '[Follow] Delete banner fail',
  GetSummaryData = '[Follow] Get summary data',
  GetSummaryDataSuccess = '[Follow] Get summary data success',
  GetSummaryDataPending = '[Follow] Get summary data pending',
  GetSummaryDataFail = '[Follow] Get summary data fail',

  ChangeClpUsd = "[Follow] Change clp usd",
  ChangeClpUsdSuccess = "[Follow] Change clp usd success",
  ChangeClpUsdFail = "[Follow] Change clp usd fail",

  FollowsNoMembers = "[Follow] follow no members",
  FollowsNoMembersSuccess = "[Follow] follow no members success",
  FollowsNoMembersFail = "[Follow] follow no members fail",

  FollowsTableCountryBuyer = "[Follow] follow table country buyer",
  FollowsTableCountryBuyerSuccess = "[Follow] follow table country buyer success",
  FollowsTableCountryBuyerFail = "[Follow] follow table country buyer fail",
  
  FollowsChargeComplete = "[Follow] follow charge complete",
  FollowsChargeCompleteSuccess = "[Follow] follow charge complete success",
  FollowsChargeCompleteFail = "[Follow] follow charge complete fail",
  
  FollowsCountryBuyer = "[Follow] follow country buyer",
  FollowsCountryBuyerSuccess = "[Follow] follow country buyer success",
  FollowsCountryBuyerFail = "[Follow] follow country buyer fail",

  FollowsCancel = "[Follow] follow cancel",
  FollowsCancelSuccess = "[Follow] follow cancel success",
  FollowsCancelFail = "[Follow] follow cancel fail",
  
  ChangeNameFollow = "[Follow] follow change name",
  ChangeNameFollowSuccess = "[Follow] follow change name success",
  ChangeNameFollowFail = "[Follow] follow change name fail",

  GetFollowYears = "[Follow] get follow years",
  GetFollowYearsSuccess = "[Follow] get follow years success",
  GetFollowYearsFail = "[Follow] get follow years fail",
}

export class DeleteBanner implements Action {
  readonly type = FollowActionTypes.DeleteBanner;
  constructor(public followId: number, public position: any) {}
}

export class DeleteBannerSuccess implements Action {
  readonly type = FollowActionTypes.DeleteBannerSuccess;
  constructor(public data?: any) {}
}

export class DeleteBannerFail implements Action {
  readonly type = FollowActionTypes.DeleteBannerFail;
  constructor(public error?: any) {}
}

export class UploadBanner implements Action {
  readonly type = FollowActionTypes.UploadBanner;
  constructor(public link: any, public file: any, public followId?: number) {}
}

export class UploadBannerSuccess implements Action {
  readonly type = FollowActionTypes.UploadBannerSuccess;
  constructor(public data: any) {}
}

export class UploadBannerFail implements Action {
  readonly type = FollowActionTypes.UploadBannerFail;
  constructor(public error: any) {}
}

export class GetBannerLink implements Action {
  readonly type = FollowActionTypes.GetBannerLink;
  constructor(
    public followId: any,
    public file: any,
    public fileableType: string
  ) {}
}

export class GetBannerLinkFail implements Action {
  readonly type = FollowActionTypes.GetBannerLinkFail;
  constructor(public error: any) {}
}

export class GetBannerShowroomFood implements Action {
  readonly type = FollowActionTypes.GetBannerShowroomFood;
  constructor(public followId: number) {}
}

export class GetBannerShowroomFoodSuccess implements Action {
  readonly type = FollowActionTypes.GetBannerShowroomFoodSuccess;
  constructor(public banner?: any) {}
}

export class GetBannerShowroomFoodFail implements Action {
  readonly type = FollowActionTypes.GetBannerShowroomFoodFail;
  constructor(public error?: any) {}
}

export class Load implements Action {
  readonly type = FollowActionTypes.Load;
  constructor(public options?: any) { }
}

export class LoadSuccess implements Action {
  readonly type = FollowActionTypes.LoadSuccess;
  constructor(public follows: Follow[]) { }
}

export class LoadFail implements Action {
  readonly type = FollowActionTypes.LoadFail;
  constructor(public error: any) { }
}

export class LoadSingle implements Action {
  readonly type = FollowActionTypes.LoadSingle;
  constructor(public id: number) { }
}

export class LoadSingleSuccess implements Action {
  readonly type = FollowActionTypes.LoadSingleSuccess;
  constructor(public follow: Follow) { }
}

export class LoadSingleFail implements Action {
  readonly type = FollowActionTypes.LoadSingleFail;
  constructor(public error: any) { }
}

export class CreateSetting implements Action {
  readonly type = FollowActionTypes.CreateSetting;
  constructor(public followId: number, public data: any) { }
}

export class CreateSettingSuccess implements Action {
  readonly type = FollowActionTypes.CreateSettingSuccess;
  constructor(public followId: number, public setting: any) { }
}

export class CreateSettingFail implements Action {
  readonly type = FollowActionTypes.CreateSettingFail;
  constructor(public error: any) { }
}

export class Update implements Action {
  readonly type = FollowActionTypes.Update;
  constructor(public followId: number, public data: any) { }
}

export class UpdateSuccess implements Action {
  readonly type = FollowActionTypes.UpdateSuccess;
  constructor(public followId: number, public data: any) { }
}

export class UpdateFail implements Action {
  readonly type = FollowActionTypes.UpdateFail;
  constructor(public error: any) { }
}

export class UpdateOne implements Action {
  readonly type = FollowActionTypes.UpdateOne;
  constructor(public follow: Follow) { }
}

export class LoadCountries implements Action {
  readonly type = FollowActionTypes.LoadCountries;
  constructor(public data: any) { }
}

export class LoadCountriesSuccess implements Action {
  readonly type = FollowActionTypes.LoadCountriesSuccess;
  constructor(public setting: any) { }
}

export class LoadCountriesFail implements Action {
  readonly type = FollowActionTypes.LoadCountriesFail;
  constructor(public error: any) { }
}

export class UpsertSetting implements Action {
  readonly type = FollowActionTypes.UpsertSetting;
  constructor(public followId: number, public setting: any) { }
}

export class SetCountries implements Action {
  readonly type = FollowActionTypes.SetCountries;
  constructor(public countries: Country[]) { }
}

export class AddOne implements Action {
  readonly type = FollowActionTypes.AddOne;
  constructor(public follow: Follow) { }
}

export class Destroy implements Action {
  readonly type = FollowActionTypes.Destroy;
  constructor(public id: number) { }
}

export class GetFollowYears implements Action {
  readonly type = FollowActionTypes.GetFollowYears;
  constructor() { }
}

export class GetFollowYearsSuccess implements Action {
  readonly type = FollowActionTypes.GetFollowYearsSuccess;
  constructor(public data: any) { }
}
export class GetFollowYearsFail implements Action {
  readonly type = FollowActionTypes.GetFollowYearsFail;
  constructor(public error: any) { }
}

export class DestroySuccess implements Action {
  readonly type = FollowActionTypes.DestroySuccess;
  constructor(public id: number) { }
}

export class DestroyFail implements Action {
  readonly type = FollowActionTypes.DestroyFail;
  constructor(public error: any) { }
}

export class RemoveOne implements Action {
  readonly type = FollowActionTypes.RemoveOne;
  constructor(public id: number) { }
}

export class Search implements Action {
  readonly type = FollowActionTypes.Search;
  constructor(public conditions: any) { }
}

export class SearchSuccess implements Action {
  readonly type = FollowActionTypes.SearchSuccess;
  constructor(public FollowIds: number[]) { }
}

export class SearchFail implements Action {
  readonly type = FollowActionTypes.SearchFail;
  constructor(public error: any) { }
}

export class SearchClear implements Action {
  readonly type = FollowActionTypes.SearchClear;
  constructor() { }
}


export class SearchFollow implements Action {
  readonly type = FollowActionTypes.SearchFollow;
  constructor(public conditions: any) { }
}

export class SearchFollowSuccess implements Action {
  readonly type = FollowActionTypes.SearchFollowSuccess;
  constructor(public Follows: any) { }
}

export class SearchFollowFail implements Action {
  readonly type = FollowActionTypes.SearchFollowFail;
  constructor(public error: any) { }
}

export class ChangeClpUsd implements Action {
  readonly type = FollowActionTypes.ChangeClpUsd;
  constructor(public value: boolean, public followId: number) { }
}

export class ChangeClpUsdSuccess implements Action {
  readonly type = FollowActionTypes.ChangeClpUsdSuccess;
  constructor() { }
}

export class ChangeClpUsdFail implements Action {
  readonly type = FollowActionTypes.ChangeClpUsdFail;
  constructor(public error: any) { }
}

export class SearchFollowClear implements Action {
  readonly type = FollowActionTypes.SearchFollowClear;
  constructor() { }
}

export class GetSummaryData implements Action {
  readonly type = FollowActionTypes.GetSummaryData;
  constructor(public FollowId: number, public data?: any) {}
}

export class GetSummaryDataSuccess implements Action {
  readonly type = FollowActionTypes.GetSummaryDataSuccess;
  constructor(public data?: any) {}
}

export class GetSummaryDataPending implements Action {
  readonly type = FollowActionTypes.GetSummaryDataPending;
  constructor(public data?: any) {}
}

export class GetSummaryDataFail implements Action {
  readonly type = FollowActionTypes.GetSummaryDataFail;
  constructor(public error?: any) {}
}

export class FollowsNoMembers implements Action {
  readonly type = FollowActionTypes.FollowsNoMembers;
  constructor() {}
}

export class FollowsNoMembersSuccess implements Action {
  readonly type = FollowActionTypes.FollowsNoMembersSuccess;
  constructor(public data?: any) {}
}

export class FollowsNoMembersFail implements Action {
  readonly type = FollowActionTypes.FollowsNoMembersFail;
  constructor(public error?: any) {}
}

export class FollowsTableCountryBuyer implements Action {
  readonly type = FollowActionTypes.FollowsTableCountryBuyer;
  constructor(public followId: number) {}
}

export class FollowsTableCountryBuyerSuccess implements Action {
  readonly type = FollowActionTypes.FollowsTableCountryBuyerSuccess;
  constructor(public data?: any) {}
}

export class FollowsTableCountryBuyerFail implements Action {
  readonly type = FollowActionTypes.FollowsTableCountryBuyerFail;
  constructor(public error?: any) {}
}

export class FollowsChargeComplete implements Action {
  readonly type = FollowActionTypes.FollowsChargeComplete;
  constructor(
    public followId: number,
    public countryId: number,
    public userId: number
  ) {}
}

export class FollowsChargeCompleteSuccess implements Action {
  readonly type = FollowActionTypes.FollowsChargeCompleteSuccess;
  constructor(public data?: any) {}
}

export class FollowsChargeCompleteFail implements Action {
  readonly type = FollowActionTypes.FollowsChargeCompleteFail;
  constructor(public error?: any) {}
}



export class FollowsCountryBuyer implements Action {
  readonly type = FollowActionTypes.FollowsCountryBuyer;
  constructor(
    public followId: number,
    public countryId: number,
    public userId: number
  ) {}
}

export class FollowsCountryBuyerSuccess implements Action {
  readonly type = FollowActionTypes.FollowsCountryBuyerSuccess
  constructor(public data?: any) {}
}

export class FollowsCountryBuyerFail implements Action {
  readonly type = FollowActionTypes.FollowsCountryBuyerFail;
  constructor(public error?: any) {}
}

export class FollowsCancel implements Action {
  readonly type = FollowActionTypes.FollowsCancel;
  constructor(public followId: number ) {}
}

export class FollowsCancelSuccess implements Action {
  readonly type = FollowActionTypes.FollowsCancelSuccess
  constructor(public data?: any) {}
}

export class FollowsCancelFail implements Action {
  readonly type = FollowActionTypes.FollowsCancelFail;
  constructor(public error?: any) {}
}

export class ChangeNameFollow implements Action {
  readonly type = FollowActionTypes.ChangeNameFollow;
  constructor(public name: any, public followId: number) {}
}

export class ChangeNameFollowSuccess implements Action {
  readonly type = FollowActionTypes.ChangeNameFollowSuccess
  constructor(public data?: any) {}
}

export class ChangeNameFollowFail implements Action {
  readonly type = FollowActionTypes.ChangeNameFollowFail;
  constructor(public error?: any) {}
}

export type FollowActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | LoadSingle
  | LoadSingleSuccess
  | LoadSingleFail
  | AddOne
  | CreateSetting
  | CreateSettingSuccess
  | CreateSettingFail
  | UpsertSetting
  | Destroy
  | DestroySuccess
  | DestroyFail
  | RemoveOne
  | Update
  | UpdateSuccess
  | UpdateFail
  | UpdateOne
  | LoadCountries
  | LoadCountriesFail
  | LoadCountriesSuccess
  | Search
  | SearchSuccess
  | SearchFail
  | SearchClear
  | SearchFollow
  | SearchFollowSuccess
  | SearchFollowFail
  | SearchFollowClear
  | GetBannerShowroomFood
  | GetBannerShowroomFoodSuccess
  | GetBannerShowroomFoodFail
  | GetBannerLink
  | GetBannerLinkFail
  | UploadBanner
  | UploadBannerSuccess
  | UploadBannerFail
  | DeleteBanner
  | DeleteBannerSuccess
  | DeleteBannerFail
  | GetSummaryData
  | GetSummaryDataSuccess
  | GetSummaryDataPending
  | GetSummaryDataFail
  | ChangeClpUsd
  | ChangeClpUsdSuccess
  | ChangeClpUsdFail
  | FollowsNoMembers
  | FollowsNoMembersSuccess
  | FollowsNoMembersFail
  | FollowsTableCountryBuyer
  | FollowsTableCountryBuyerSuccess
  | FollowsTableCountryBuyerFail
  | FollowsChargeComplete
  | FollowsChargeCompleteSuccess
  | FollowsChargeCompleteFail
  | FollowsCountryBuyer
  | FollowsCountryBuyerSuccess
  | FollowsCountryBuyerFail
  | FollowsCancel
  | FollowsCancelSuccess
  | FollowsCancelFail
  | ChangeNameFollow
  | ChangeNameFollowSuccess
  | ChangeNameFollowFail
  | GetFollowYears
  | GetFollowYearsSuccess
  | GetFollowYearsFail;

